import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import RecordsErrorBoundary from '../../errors/RecordsErrorBoundary';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-sidebar/universa... Remove this comment to see the full error message
import { CRM_RECORD_LEFT } from 'customer-data-sidebar/universal/cardLocationConstants';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-sidebar/SidebarE... Remove this comment to see the full error message
import SidebarError from 'customer-data-sidebar/SidebarError';
import CardsSidebar from '../sidebar/CardsSidebar';
import MiniProfileHighlightContainerAsync from './sidebar/highlight/mini/MiniProfileHighlightContainerAsync';
import { NavMarker } from 'react-rhumb';
import RecordHighlightWrapperAsync from './RecordHighlightWrapperAsync';
import { useRefWidth } from './hooks/useRefWidth';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-objects-ui-compo... Remove this comment to see the full error message

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
import { PermissionsContext } from 'customer-data-sidebar/universal/context/PermissionsContext';
import { useRecordPermissions } from '../permissions/RecordPermissionsContext';
import useAuth from './hooks/useAuth';
import styled from 'styled-components';
import { View } from 'foundations-components/components/View';
import FullHeightScrollContainer from './common/components/FullHeightScrollContainer';
import throttle from 'transmute/throttle';
import { Flex } from 'foundations-components/components/Flex';
import { GLOBAL_NAVIGATION_TOOLBAR_DEFAULT_HEIGHT } from 'nav-meta/constants';
import { HIGHLIGHT_CARD } from '../../constants/gates';
import { CRM_LOCATION_NAMES } from 'crm-cards-sdk/constants/CrmLocationName';
import { getGates } from 'quartz-core/framework/auth/app';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GLOBAL_NAV_HEIGHT = parseInt(GLOBAL_NAVIGATION_TOOLBAR_DEFAULT_HEIGHT, 10);
const MINI_HIGHLIGHT_TRANSITION_DURATION_MILLIS = 200;
const SidebarRefContainer = styled.div.withConfig({
  displayName: "LeftSidebar__SidebarRefContainer",
  componentId: "sc-1clyca4-0"
})(["height:100%;"]);
const CardsContainer = styled.div.withConfig({
  displayName: "LeftSidebar__CardsContainer",
  componentId: "sc-1clyca4-1"
})(["flex-grow:1;display:flex;"]);
const scrollContainerProps = {
  'data-scroll-trackable-container': 'left-sidebar'
};
const LeftSidebar = ({
  objectType,
  subjectId
}) => {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const highlightRef = useRef(null);
  const sidebarRef = useRef(null);
  const sidebarWidth = useRefWidth(sidebarRef);
  const [miniHighlightState, setMiniHighlightState] = useState('Hidden');
  useEffect(() => {
    if (miniHighlightState === 'Hiding') {
      setTimeout(() => {
        setMiniHighlightState('Hidden');
      }, MINI_HIGHLIGHT_TRANSITION_DURATION_MILLIS);
    }
  }, [miniHighlightState]);
  const scrollElementRef = useRef(null);
  const handleScroll = useCallback(() => {
    const highlightEl = highlightRef.current;
    if (!highlightEl) {
      return;
    }
    const {
      bottom
    } = highlightEl.getBoundingClientRect();
    if (bottom <= GLOBAL_NAV_HEIGHT && miniHighlightState !== 'Visible') {
      setMiniHighlightState('Visible');
    } else if (bottom > GLOBAL_NAV_HEIGHT && miniHighlightState === 'Visible') {
      setMiniHighlightState('Hiding');
    }
  }, [miniHighlightState]);
  useEffect(() => {
    const scrollElement = scrollElementRef.current;
    if (!scrollElement) return;
    const throttleId = throttle(50, handleScroll);
    scrollElement.addEventListener('scroll', throttleId);
    return () => {
      scrollElement.removeEventListener('scroll', throttleId);
    };
  }, [handleScroll]);
  const auth = useAuth();
  const {
    currentUserCanView,
    currentUserCanCreate,
    currentUserCanEdit,
    currentUserCanDelete,
    currentUserCanMerge
  } = useRecordPermissions();
  const crmRecordLeftSuccessMarker = useMemo(() => /*#__PURE__*/_jsx(NavMarker, {
    name: "RECORD_PROPERTIES"
  }), []);
  const crmRecordLeftErrorMarker = useMemo(() => /*#__PURE__*/_jsx(NavMarker, {
    name: "LEFT_SIDEBAR_ERROR"
  }), []);
  const crmRecordHighlightSuccessMarker = useMemo(() => /*#__PURE__*/_jsx(NavMarker, {
    name: "CRM_RECORD_HIGHLIGHT"
  }), []);
  const crmRecordHighlightErrorMarker = useMemo(() => /*#__PURE__*/_jsx(NavMarker, {
    name: "CRM_RECORD_HIGHLIGHT_ERROR"
  }), []);
  const isUngatedForHighlightLocation = getGates().has(HIGHLIGHT_CARD);
  const highlight = isUngatedForHighlightLocation ? /*#__PURE__*/_jsx(CardsSidebar, {
    cardLocation: CRM_LOCATION_NAMES.CRM_RECORD_HIGHLIGHT,
    objectType: objectType,
    RhumbMarkerSuccess: crmRecordHighlightSuccessMarker,
    RhumbMarkerError: crmRecordHighlightErrorMarker,
    subjectId: subjectId
  }, "profile-sidebar-async") : /*#__PURE__*/_jsx(PermissionsContext.Provider, {
    value: {
      scopes: auth.user.scopes,
      gates: auth.gates,
      canView: currentUserCanView,
      canCreate: currentUserCanCreate,
      canEditSubject: currentUserCanEdit,
      canDeleteSubject: currentUserCanDelete,
      canMergeSubject: currentUserCanMerge,
      readOnly: false
    },
    children: /*#__PURE__*/_jsx(RecordHighlightWrapperAsync, {
      highlightRef: highlightRef,
      objectType: objectType,
      subjectId: subjectId
    })
  });
  return /*#__PURE__*/_jsx(SidebarRefContainer, {
    ref: sidebarRef,
    children: /*#__PURE__*/_jsx(View, {
      as: "aside",
      blockSize: "100%",
      "data-onboarding": "left-sidebar",
      "data-selenium-test": "left-sidebar",
      "data-test-id": "left-sidebar",
      paddingInlineStart: isTrellis ? '600' : '0',
      paddingInlineEnd: isTrellis ? '400' : '0',
      paddingBlockStart: isTrellis ? '600' : '0',
      children: /*#__PURE__*/_jsx(FullHeightScrollContainer, {
        scrollElementRef: scrollElementRef,
        scrollContainerProps: scrollContainerProps,
        children: /*#__PURE__*/_jsx(RecordsErrorBoundary, {
          ErrorComponent: SidebarError,
          boundaryName: "ProfileThreeColumn_LeftSidebarError",
          children: /*#__PURE__*/_jsxs(Flex, {
            minBlockSize: "100%",
            flexDirection: "column",
            paddingBlockEnd: "1300",
            children: [/*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(MiniProfileHighlightContainerAsync, {
                objectType: objectType,
                subjectId: subjectId,
                state: miniHighlightState,
                width: sidebarWidth
              }, "mini-highlight-container"), !isUngatedForHighlightLocation && isTrellis ? /*#__PURE__*/_jsx(CardWrapper, {
                margin: "0",
                children: highlight
              }) : highlight]
            }), !isTrellis && /*#__PURE__*/_jsx(HR, {
              marginBlockStart: "0",
              marginBlockEnd: "-25"
            }), /*#__PURE__*/_jsx(CardsContainer, {
              children: /*#__PURE__*/_jsx(View, {
                inlineSize: "100%",
                marginInline: '0',
                marginBlockStart: isTrellis ? '400' : '0',
                children: /*#__PURE__*/_jsx(CardsSidebar, {
                  cardLocation: CRM_RECORD_LEFT,
                  objectType: objectType,
                  RhumbMarkerSuccess: crmRecordLeftSuccessMarker,
                  RhumbMarkerError: crmRecordLeftErrorMarker,
                  subjectId: subjectId
                }, "profile-sidebar-async")
              })
            })]
          })
        })
      })
    })
  });
};
LeftSidebar.displayName = 'LeftSidebar';
export default LeftSidebar;